<template>
	<div class="menubar is-hidden" :style="{ display: focused ? 'flex' : 'none' }">
		<md-dialog
			v-if="showURLModal"
			:md-active="showURLModal"
			style="font-family: 'Montserrat', sans-serif; z-index: 9999"
		>
			<div style="width: 500px">
				<div class="dialog-header">
					<span style="margin-top: auto; margin-bottom: auto; font-size: 18px">{{
						$t("adding-new-url")
					}}</span>
					<div style="margin-left: auto; margin-right: 0">
						<md-button @click="showURLModal = false" class="md-icon-button" style="margin-right: -5px">
							<md-icon style="color: white">close</md-icon>
						</md-button>
					</div>
				</div>
				<div class="dialog-body">
					<div class="container">
						<span>{{ $t("url") }}</span>
						<el-input v-model="urlvalue" placeholder="URL">
							<template slot="prepend">https://</template>
						</el-input>
					</div>
				</div>
				<div class="dialog-footer" style="width: 100%">
					<div style="margin-left: auto; margin-right: 0">
						<md-button class="cancel" @click="showURLModal = false">
							{{ $t("cancel") }}
						</md-button>
						<md-button class="add" @click="insertUrl(urlvalue)">
							<span>{{ $t("save") }}</span>
						</md-button>
					</div>
				</div>
			</div>
		</md-dialog>
		<template v-for="(item, index) in items">
			<div class="divider" v-if="item.type === 'divider'" :key="index" />
			<menu-item
				@varpop="
					() => {
						$emit('varpop')
					}
				"
				v-else
				:key="index"
				v-bind="item"
			/>
		</template>
	</div>
</template>
<script>
import MenuItem from "./MenuItem.vue"
import InputModal from "@/modules/_common/modal/input-modal"

export default {
	components: {
		MenuItem,
		InputModal
	},
	props: {
		editor: {
			type: Object,
			required: true
		},
		focused: {
			type: Boolean
		}
	},
	data() {
		return {
			showURLModal: false,
			urlvalue: undefined,
			items: [
				{
					icon: "bold",
					title: this.$t("bold"),
					action: () => this.editor.chain().focus().toggleBold().run(),
					isActive: () => this.editor.isActive("bold"),
					isVisible: () => true
				},
				{
					icon: "italic",
					title: this.$t("italic"),
					action: () => this.editor.chain().focus().toggleItalic().run(),
					isActive: () => this.editor.isActive("italic"),
					isVisible: () => true
				},
				{
					icon: "strikethrough",
					title: this.$t("strikethrough"),
					action: () => this.editor.chain().focus().toggleStrike().run(),
					isActive: () => this.editor.isActive("strike"),
					isVisible: () => true
				},
				{
					icon: "underline",
					title: this.$t("underline"),
					action: () => this.editor.chain().focus().toggleUnderline().run(),
					isActive: () => this.editor.isActive("underline"),
					isVisible: () => true
				},
				{
					icon: "mark-pen-line",
					title: this.$t("highlight"),
					action: () => this.editor.chain().focus().toggleHighlight().run(),
					isActive: () => this.editor.isActive("highlight"),
					isVisible: () => true
				},
				{
					type: "divider",
					isVisible: () => true
				},
				{
					icon: "h-1",
					title: this.$t("h1"),
					action: () => this.editor.chain().focus().toggleHeading({ level: 1 }).run(),
					isActive: () => this.editor.isActive("heading", { level: 1 }),
					isVisible: () => true
				},
				{
					icon: "h-2",
					title: this.$t("h2"),
					action: () => this.editor.chain().focus().toggleHeading({ level: 2 }).run(),
					isActive: () => this.editor.isActive("heading", { level: 2 }),
					isVisible: () => true
				},
				{
					icon: "h-3",
					title: this.$t("h3"),
					action: () => this.editor.chain().focus().toggleHeading({ level: 3 }).run(),
					isActive: () => this.editor.isActive("heading", { level: 3 }),
					isVisible: () => true
				},

				{
					icon: "font-size-2",
					title: this.$t("size"),
					action: size => this.editor.chain().focus().setSize(size).run(),

					isVisible: () => true,
					is_procedural: true,
					dropdown: true
				},

				{
					icon: "font-size",
					title: this.$t("text-type"),
					isVisible: () => true,
					dropdown: [
						{
							title: "Default",
							action: () => this.editor.chain().focus().unsetFontFamily().run()
						},
						{
							title: "Comic Sans",
							action: () => this.editor.chain().focus().setFontFamily("Comic Sans MS, Comic Sans").run()
						},
						{
							title: "Serif",
							action: () => this.editor.chain().focus().setFontFamily("serif").run()
						},
						{
							title: "Monospace",
							action: () => this.editor.chain().focus().setFontFamily("monospace").run()
						},
						{
							title: "Cursive",
							action: () => this.editor.chain().focus().setFontFamily("cursive").run()
						}
					]
				},

				{
					icon: "font-color",
					title: this.$t("text-color"),
					isVisible: () => true,
					subelements: [
						{
							icon: "font-color",
							title: this.$t("black"),
							action: () => this.editor.chain().focus().setColor("#000000").run(),
							isVisible: () => true
						},
						{
							icon: "font-color",
							title: this.$t("red"),
							color: "#F44336",
							action: () => this.editor.chain().focus().setColor("rgb(255,0,0)").run(),
							isVisible: () => true
						},
						{
							icon: "font-color",
							title: this.$t("blue"),
							color: "#2196F3",
							action: () => this.editor.chain().focus().setColor("#2196F3").run(),
							isVisible: () => true
						},
						{
							icon: "font-color",
							title: this.$t("green"),
							color: "#8BC34A",
							action: () => this.editor.chain().focus().setColor("#8BC34A").run(),
							isVisible: () => true
						},
						{
							icon: "font-color",
							title: this.$t("gray"),
							color: "#9E9E9E",
							action: () => this.editor.chain().focus().setColor("#9E9E9E").run(),
							isVisible: () => true
						},
						{
							icon: "font-color",
							title: this.$t("brown"),
							color: "#795548",
							action: () => this.editor.chain().focus().setColor("#795548").run(),
							isVisible: () => true
						},
						{
							icon: "font-color",
							title: this.$t("yellow"),
							color: "#FFEE58",
							action: () => this.editor.chain().focus().setColor("#FFEE58").run(),
							isVisible: () => true
						},
						{
							icon: "font-color",
							title: this.$t("purple"),
							color: "#9575CD",
							action: () => this.editor.chain().focus().setColor("#9575CD").run(),
							isVisible: () => true
						}
					]
				},

				{
					type: "divider",
					isVisible: () => true
				},
				{
					icon: "align-justify",
					title: this.$t("align"),
					isVisible: () => true,
					subelements: [
						{
							icon: "align-left",
							title: this.$t("align-left"),
							action: () => this.editor.chain().focus().setTextAlign("left").run(),
							isActive: () => this.editor.isActive("left"),
							isVisible: () => true
						},
						{
							icon: "align-center",
							title: this.$t("align-center"),
							action: () => this.editor.chain().focus().setTextAlign("center").run(),
							isActive: () => this.editor.isActive("center"),
							isVisible: () => true
						},
						{
							icon: "align-right",
							title: this.$t("align-right"),
							action: () => this.editor.chain().focus().setTextAlign("right").run(),
							isActive: () => this.editor.isActive("right"),
							isVisible: () => true
						},
						{
							icon: "align-justify",
							title: this.$t("justify"),
							action: () => this.editor.chain().focus().setTextAlign("justify").run(),
							isActive: () => this.editor.isActive("justify"),
							isVisible: () => true
						}
					]
				},
				{
					icon: "paragraph",
					title: this.$t("paragraph"),
					action: () => this.editor.chain().focus().setParagraph().run(),
					isActive: () => this.editor.isActive("paragraph"),
					isVisible: () => true
				},
				{
					icon: "list-unordered",
					title: this.$t("list-unordered"),
					action: () => this.editor.chain().focus().toggleBulletList().run(),
					isActive: () => this.editor.isActive("bulletList"),
					isVisible: () => true
				},
				{
					icon: "list-ordered",
					title: this.$t("list-ordered"),
					action: () => this.editor.chain().focus().toggleOrderedList().run(),
					isActive: () => this.editor.isActive("orderedList"),
					isVisible: () => true
				},

				{
					icon: "list-ordered",
					title: this.$t("list-ordered-letters"),
					action: () => this.editor.chain().focus().toggleOrderedListLetters().run(),
					isActive: () => this.editor.isActive("orderedListLetters"),
					isVisible: () => true
				},
				{
					icon: "list-check-2",
					title: this.$t("task-list"),
					action: () => this.editor.chain().focus().toggleTaskList().run(),
					isActive: () => this.editor.isActive("taskList"),
					isVisible: () => true
				},
				{
					icon: "double-quotes-l",
					title: this.$t("quote"),
					action: () => this.editor.chain().focus().toggleBlockquote().run(),
					isActive: () => this.editor.isActive("blockquote"),
					isVisible: () => true
				},
				{
					type: "divider",
					isVisible: () => true
				},
				{
					icon: "text-wrap",
					title: this.$t("hard-break"),
					action: () => this.editor.chain().focus().setHardBreak().run(),
					isVisible: () => true
				},
				{
					icon: "format-clear",
					title: this.$t("clear-format"),
					action: () => this.editor.chain().focus().clearNodes().unsetAllMarks().run(),
					isVisible: () => true
				},
				{
					type: "divider",
					isVisible: () => true
				},
				{
					icon: "arrow-go-back-line",
					title: this.$t("cancel"),
					action: () => this.editor.chain().focus().undo().run(),
					isVisible: () => true
				},
				{
					icon: "arrow-go-forward-line",
					title: this.$t("redo"),
					action: () => this.editor.chain().focus().redo().run(),
					isVisible: () => true
				},
				{
					type: "divider",
					isVisible: () => true
				},
				{
					icon: "bookmark-3-fill",
					title: this.$t("variables"),
					action: () => {
						this.$emit("varpop")
					},
					isVisible: () => true
				},
				{
					icon: "link",
					title: this.$t("add-link"),
					isVisible: () => !this.editor.isActive("link"),
					action: () => {
						this.showURLModal = true
					}
				},
				{
					icon: "link-unlink",
					title: this.$t("remove-link"),
					isVisible: () => this.editor.isActive("link"),
					action: () => {
						this.editor.chain().focus().unsetLink().run()
					}
				},

				{
					icon: "table-line",
					title: this.$t("table-menu"),
					isVisible: () => true,
					subelements: [
						{
							icon: "table-line",
							title: this.$t("table-add"),
							action: () =>
								this.editor
									.chain()
									.focus()
									.insertTable({
										rows: 3,
										cols: 3,
										withHeaderRow: true
									})
									.run(),
							isVisible: () => true
						},
						{
							icon: "close-line",
							title: this.$t("table-delete"),
							action: () => this.editor.chain().focus().deleteTable().run(),
							isVisible: () => true
						},
						{
							icon: "insert-column-left",
							title: this.$t("table-add-col-left"),
							action: () => this.editor.chain().focus().addColumnBefore().run(),
							isVisible: () => true
						},
						{
							icon: "insert-column-right",
							title: this.$t("table-add-col-right"),
							action: () => this.editor.chain().focus().addColumnAfter().run(),
							isVisible: () => true
						},
						{
							icon: "delete-column",
							title: this.$t("table-delete-col"),
							action: () => this.editor.chain().focus().deleteColumn().run(),
							isVisible: () => true
						},
						{
							icon: "insert-row-top",
							title: this.$t("table-add-row-above"),
							action: () => this.editor.chain().focus().addRowBefore().run(),
							isVisible: () => true
						},
						{
							icon: "insert-row-bottom",
							title: this.$t("table-add-row-below"),
							action: () => this.editor.chain().focus().addRowAfter().run(),
							isVisible: () => true
						},
						{
							icon: "delete-row",
							title: this.$t("table-delete-row"),
							action: () => this.editor.chain().focus().deleteRow().run(),
							isVisible: () => true
						},
						{
							icon: "merge-cells-horizontal",
							title: this.$t("table-join-cell"),
							action: () => this.editor.chain().focus().mergeCells().run(),
							isVisible: () => true
						},
						{
							icon: "split-cells-horizontal",
							title: this.$t("table-split-cell"),
							action: () => this.editor.chain().focus().splitCell().run(),
							isVisible: () => true
						},
						{
							icon: "layout-column-fill",
							title: this.$t("table-highlight-col"),
							action: () => this.editor.chain().focus().toggleHeaderColumn().run(),
							isVisible: () => true
						},
						{
							icon: "layout-row-fill",
							title: this.$t("table-highlight-row"),
							action: () => this.editor.chain().focus().toggleHeaderRow().run(),
							isVisible: () => true
						},
						{
							icon: "bank-card-2-line",
							title: this.$t("table-highlight-cell"),
							action: () => this.editor.chain().focus().toggleHeaderCell().run(),
							isVisible: () => true
						}
					]
				}
			]
		}
	},
	methods: {
		showVarModal(command) {
			this.$refs.videoModal.showModal(command)
		},
		insertUrl(val) {
			if (val.trim().indexOf("https://") === 0) {
				val = val.replace("https://", "")
			}
			if (val.trim().indexOf("http://") === 0) {
				val = val.replace("http://", "")
			}

			this.editor
				.chain()
				.focus()
				.extendMarkRange("link")
				.setLink({ href: `//${val}` })
				.run()
			this.showURLModal = false
			this.urlvalue = undefined
		}
	}
}
</script>
<style lang="scss" scoped>
.divider {
	width: 2px;
	height: 1.25rem;
	background-color: rgba(0, 0, 0, 0.1);
	margin-left: 0.5rem;
	margin-right: 0.75rem;
}
</style>
